import { Point } from '@/types';
import { AngleLine } from '@/utils/math/types';

/**
 * closest point on a line from the given point is the intersection of a perpendicular line through this point
 * line: y = m * x + b
 * any line with -m * x is perpendicular but we want the one that goes through the given point
 *  point.y = -m * point.x + perpendicularB       | + (m * point.x)
 *  perpendicularB = m * point.x + point.y
 * perpendicular line through given point: y = -m * x + m * point.x + point.y
 * intersection of both lines:
 *  m * x + b = -m * x + m * point.x + point.y    | + (m * x)
 *  2 * m * x + b = m * point.x + point.y         | - b
 *  2 * m * x = m * point.x + point.y - b         | / (2 * m)
 *  x = (m * point.x + point.y - b) / (2 * m)
 */

export const getClosestPointOnAngleLine = (line: AngleLine, point: Point) => {
  const x = ((line.m * point.x + point.y - line.b) / 2) * line.m;
  const y = line.m * x + line.b;
  return { x, y };
};
